// extracted by mini-css-extract-plugin
module.exports = {"NumericRangeFeature":"wc_a bhj_b bhj_ux"};